import { useEffect, useMemo, useState } from "react";
import {
    Users,
    UserCheck,
    UserX,
    UserPlus,
    RefreshCw,
    Download,
} from "lucide-react";

import {
    getCustomers,
} from "../services/adminApi";

import CustomerTable from "../components/customer/CustomerTable";
import CustomerFilters from "../components/customer/CustomerFilters";

import "./Customers.css";

function Customers() {

    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);

    const [filters, setFilters] = useState({
        search: "",
        status: "",
        city: "",
        sort: "latest",
    });

    const loadCustomers = async () => {

        try {

            setLoading(true);

            const res = await getCustomers();

            setCustomers(res.data.customers || []);

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadCustomers();

    }, []);

    const handleFilterChange = (key, value) => {

        setFilters((prev) => ({
            ...prev,
            [key]: value,
        }));

    };

    const filteredCustomers = useMemo(() => {

        let data = [...customers];

        if (filters.search) {

            const search = filters.search.toLowerCase();

            data = data.filter((customer) =>

                customer.name?.toLowerCase().includes(search) ||

                customer.email?.toLowerCase().includes(search) ||

                customer.phone?.toLowerCase().includes(search)

            );

        }

        if (filters.status) {

            const active = filters.status === "active";

            data = data.filter(

                (customer) => customer.isActive === active

            );

        }

        if (filters.city) {

            data = data.filter((customer) =>

                customer.city

                    ?.toLowerCase()

                    .includes(filters.city.toLowerCase())

            );

        }

        switch (filters.sort) {

            case "oldest":

                data.sort(

                    (a, b) =>

                        new Date(a.createdAt) -

                        new Date(b.createdAt)

                );

                break;

            case "az":

                data.sort(

                    (a, b) =>

                        a.name.localeCompare(b.name)

                );

                break;

            case "za":

                data.sort(

                    (a, b) =>

                        b.name.localeCompare(a.name)

                );

                break;

            default:

                data.sort(

                    (a, b) =>

                        new Date(b.createdAt) -

                        new Date(a.createdAt)

                );

        }

        return data;

    }, [customers, filters]);

    const totalCustomers = customers.length;

    const activeCustomers = customers.filter(

        (c) => c.isActive

    ).length;

    const blockedCustomers = customers.filter(

        (c) => !c.isActive

    ).length;

    const newCustomers = customers.filter((c) => {

        const joined = new Date(c.createdAt);

        const now = new Date();

        return (

            joined.getMonth() === now.getMonth() &&

            joined.getFullYear() === now.getFullYear()

        );

    }).length;

    return (

        <div className="customers-page">

            <div className="customers-header">

                <div>

                    <h1>Customer Management</h1>

                    <p>

                        Manage all registered customers.

                    </p>

                </div>

                <div className="customers-actions">

                    <button className="export-btn">

                        <Download size={18} />

                        Export

                    </button>

                    <button

                        className="refresh-btn"

                        onClick={loadCustomers}

                    >

                        <RefreshCw size={18} />

                        Refresh

                    </button>

                </div>

            </div>

            <div className="customer-overview">

                <div className="overview-card">

                    <div className="overview-icon total">

                        <Users size={24} />

                    </div>

                    <div>

                        <h2>{totalCustomers}</h2>

                        <p>Total Customers</p>

                    </div>

                </div>

                <div className="overview-card">

                    <div className="overview-icon active">

                        <UserCheck size={24} />

                    </div>

                    <div>

                        <h2>{activeCustomers}</h2>

                        <p>Active</p>

                    </div>

                </div>

                <div className="overview-card">

                    <div className="overview-icon blocked">

                        <UserX size={24} />

                    </div>

                    <div>

                        <h2>{blockedCustomers}</h2>

                        <p>Blocked</p>

                    </div>

                </div>

                <div className="overview-card">

                    <div className="overview-icon new">

                        <UserPlus size={24} />

                    </div>

                    <div>

                        <h2>{newCustomers}</h2>

                        <p>New This Month</p>

                    </div>

                </div>

            </div>

            <CustomerFilters

                filters={filters}

                onChange={handleFilterChange}

            />

            <div className="customers-section">

                <CustomerTable

                    customers={filteredCustomers}

                    loading={loading}

                    reload={loadCustomers}

                />

            </div>

        </div>

    );

}

export default Customers;